const emptyAvatarSVG = (fill = '#888888') => `

<svg width="44" height="59" viewBox="0 0 44 59" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
        d="M35.871 31.9509C37.2435 29.3485 37.9994 26.2368 37.9994 22.7876C37.9994 22.7876 37.9331 4.10315 37.8403 3.88973C37.5419 1.61785 35.7583 0.00688448 33.5304 0.00688448C31.0904 0.00688448 29.088 1.81062 28.9819 4.28903C28.962 4.40607 28.6438 23.0974 28.6438 23.0974C28.6438 28.0818 26.2767 31.4758 21.7812 31.4758C17.2857 31.4758 14.7728 28.0818 14.7728 23.0974C14.7728 23.0974 14.786 4.10315 14.6932 3.89662C14.4014 1.61785 12.6444 0 10.4165 0C8.00964 0 6.06028 1.75554 5.90778 4.18576C5.87462 4.32345 5.58951 22.7739 5.58951 22.7739C5.58951 26.2987 6.65039 29.4656 8.08258 32.1023C3.0434 34.0438 0 38.8698 0 45.0107C0 53.2102 5.8481 59 13.8312 59H30.3014C38.2845 59 44 53.1207 44 44.8317C44 38.8009 40.8505 33.9956 35.871 31.9371V31.9509Z" 
        fill="${fill}"
    />
    <path 
        d="M38 44.5C38 48.6444 34.76 52 30.7733 52H14.2267C10.2333 52 7 48.6444 7 44.5C7 40.3556 10.24 37 14.2267 37H30.7733C34.76 37 38 40.3556 38 44.5Z" 
        fill="white"
    />
    <path
        d="M15 45.0656C15 46.1279 14.1051 47 13 47C11.8949 47 11 46.1344 11 45.0656V42.9344C11 41.8656 11.8949 41 13 41C14.0983 41 15 41.8656 15 42.9344V45.0656Z" 
        fill="${fill}"
    />
    <path
        d="M34 44.7432C34 45.9825 33.1051 47 32 47C30.8949 47 30 45.9902 30 44.7432V42.2568C30 41.0175 30.8949 40 32 40C33.1051 40 34 41.0098 34 42.2568V44.7432Z" 
        fill="${fill}"
    />
</svg>
`

export default emptyAvatarSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/emptyAvatarSVG.js